import React from "react";
import { Table ,Button,Badge} from "react-bootstrap";
// import { PaginationComponent } from "../Pagination";

export const ReturnDataTable = ({ tableStyle, tableData, handleAcceptReturn ,handleCancelReturn}) => {
  return (
    <>
      <Table borderless responsive className="bg-light">
        <thead style={tableStyle}>
          <tr className="equalWidth">
            <th>Order ID</th>
            <th>User ID</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Product ID</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Order Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(tableData) && tableData.length > 0 ? (
            tableData.map((d, i) => (
              <tr key={i} style={{ fontSize: ".9em" }} className="equalWidth">
                <td>{d?.order_id || "N/A"}</td>
                <td>{d?.user_id || "N/A"}</td>
                <td>
                  {d?.address ? (
                    <>
                      {d?.user_name},<br />
                      {d?.address},<br />
                      {d?.state},<br />
                      {d?.pincode}
                    </>
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td>{d?.mobile_no || "N/A"}</td>
                <td>{d?.product_id || "N/A"}</td>
                <td>{d?.product_name || "N/A"}</td>
                <td>{d?.quantity || 0}</td>
                <td>{d?.requested_at || "N/A"}</td>
                <td>
                  {d?.return_status === "Requested" ? (
                    <>
                      <Button
                        variant="outline-success"
                        size="sm"
                        onClick={() => handleAcceptReturn(d?.order_id)}
                        style={{ marginRight: "8px" }}
                      >
                        Accept
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleCancelReturn(d?.order_id)}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <Badge bg="secondary">{d?.return_status || "N/A"}</Badge>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center text-muted">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
